define.alias("shared/components/shared/post/secondary/caption-writer/form", "media/components/shared/post/secondary/caption-writer/form");